export const WALLET_LIST_ATTRIBUTES_CONSTANT = {
  partner: {
    type: 'select',
    key: 'partner_id',
    label: 'Partner',
  },
  sender: {
    type: 'select',
    key: 'sender_id',
    label: 'Sender',
  },
} as const;
